import React from 'react';

interface IIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

export const Delete = ({ width, height, fill = '#EC3030' }: IIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M11.3333 14.6663H4.66667C3.93029 14.6663 3.33333 14.0694 3.33333 13.333V4.66634H2V3.33301H4.66667V2.66634C4.66667 1.92996 5.26362 1.33301 6 1.33301H10C10.7364 1.33301 11.3333 1.92996 11.3333 2.66634V3.33301H14V4.66634H12.6667V13.333C12.6667 14.0694 12.0697 14.6663 11.3333 14.6663ZM4.66667 4.66634V13.333H11.3333V4.66634H4.66667ZM6 2.66634V3.33301H10V2.66634H6ZM10 11.9997H8.66667V5.99967H10V11.9997ZM7.33333 11.9997H6V5.99967H7.33333V11.9997Z"
            fill={fill}
        />
    </svg>
);
